import React from "react";
import axios from "axios";
import { Tag } from "antd";
import { saveAs } from "file-saver";

// Formato y color compartidos por las dos pestañas de Performance. Antes eran métodos
// de la clase; salieron de ahí para que "3.2 s" y el rojo de >10 s signifiquen lo mismo
// en toda la pantalla.

export const formatMs = (ms) => {
    if (ms === null || ms === undefined || isNaN(ms)) return "-";
    if (ms >= 1000) return (ms / 1000).toFixed(2) + " s";
    return Math.round(ms) + " ms";
};

export const colorMs = (ms) => {
    if (ms >= 10000) return "#cf1322";
    if (ms >= 5000) return "#fa8c16";
    if (ms >= 2000) return "#faad14";
    return "#52c41a";
};

export const formatMb = (mb) => {
    if (mb === null || mb === undefined || isNaN(mb)) return "-";
    if (mb >= 1024) return (mb / 1024).toFixed(2) + " GB";
    return Math.round(mb) + " MB";
};

export const colorPct = (pct) => {
    if (pct >= 90) return "#cf1322";
    if (pct >= 70) return "#fa8c16";
    if (pct >= 50) return "#faad14";
    return "#52c41a";
};

export const tagMetodo = (method) => {
    const colores = {
        GET: "blue",
        POST: "green",
        PUT: "orange",
        DELETE: "red",
        PATCH: "purple",
    };
    return <Tag color={colores[method] || "default"}>{method}</Tag>;
};

export const truncarPath = (path) => {
    if (!path) return "";
    if (path.length <= 38) return path;
    return "…" + path.slice(-37);
};

// Color estable por hostname: el mismo servidor tiene que ser del mismo color en todas
// las gráficas de la pantalla, o compararlas no sirve de nada.
const PALETA_SERVIDORES = ["#00BFD6", "#722ed1", "#fa8c16", "#52c41a", "#eb2f96", "#1890ff"];

export const colorServidor = (servidor) => {
    if (!servidor) return PALETA_SERVIDORES[0];
    let hash = 0;
    for (let i = 0; i < servidor.length; i++) {
        hash = (hash * 31 + servidor.charCodeAt(i)) | 0;
    }
    return PALETA_SERVIDORES[Math.abs(hash) % PALETA_SERVIDORES.length];
};

// Nombres legibles de los disparadores que guarda el muestreador.
const ETIQUETAS_DISPARADOR = {
    bloqueo: "Event loop bloqueado",
    enVueloViejo: "Request muy viejo",
    enVueloMuchos: "Muchos en vuelo",
    poolEncolado: "Pool de Mongo encolado",
    cpuAlta: "CPU alta",
    memoria: "Memoria alta",
};

export const etiquetaDisparador = (clave) => ETIQUETAS_DISPARADOR[clave] || clave;

// El pool encolado es el diagnóstico más accionable de todos: significa esperar por un
// socket de Mongo, no CPU quemada, y el arreglo es subir el pool.
export const colorDisparador = (clave) => {
    if (clave === "poolEncolado") return "magenta";
    if (clave === "bloqueo") return "red";
    if (clave === "memoria" || clave === "cpuAlta") return "volcano";
    return "orange";
};

// ── Reportes de saturación (PDF y texto) ─────────────────────────────────────
//
// El backend arma los dos con el mismo modelo que el reporte adjunto al correo; aquí solo
// se descargan o se copian. El PDF llega en base64 porque el router responde JSON.

export const pedirReporte = (endpoint, cuerpo, formato, headersToken) =>
    axios.post(endpoint, { ...cuerpo, formato }, { headers: headersToken }).then((res) => {
        if (res.data.success !== 2) throw new Error(res.data.message || "No se pudo generar el reporte");
        return res.data;
    });

export const descargarPdfBase64 = (base64, nombreArchivo) => {
    const binario = atob(base64);
    const bytes = new Uint8Array(binario.length);
    for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
    saveAs(new Blob([bytes], { type: "application/pdf" }), nombreArchivo);
};

export const descargarTexto = (texto, nombreArchivo) =>
    saveAs(new Blob([texto], { type: "text/plain;charset=utf-8" }), nombreArchivo);

// navigator.clipboard no existe fuera de un contexto seguro, y algunos navegadores lo
// niegan si pasó demasiado tiempo desde el clic (aquí hay una petición de por medio).
// Regresa false si no se pudo, para que quien llama ofrezca el .txt.
export const copiarAlPortapapeles = async (texto) => {
    try {
        await navigator.clipboard.writeText(texto);
        return true;
    } catch (err) {
        try {
            const area = document.createElement("textarea");
            area.value = texto;
            area.setAttribute("readonly", "");
            area.style.position = "fixed";
            area.style.opacity = "0";
            document.body.appendChild(area);
            area.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(area);
            return ok;
        } catch (err2) {
            return false;
        }
    }
};
